module.exports = __webpack_public_path__ + "img/delete-trash-icon.c4c06b0f.svg";